var map = {
	"./dot-blue.svg": 5720,
	"./map-pin-cluster.svg": 94319,
	"./map-pin-filled.svg": 91611,
	"./map-pin-location-blue.svg": 64931,
	"./map-pin-location.svg": 87322,
	"./map-pin-outlined.svg": 30305,
	"./map-pin-white-dot-large.svg": 19698,
	"./map-pin-white-dot-small.svg": 470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60991;